import PlatformUserService from "../../../platform/controller/PlatformUserService";
import SavegameStrategy from "./SavegameStrategy";

export default class PlatformSavegameStrategy extends SavegameStrategy {
    /**
     * @constructor
     * @param {SaveGameModel} saveGameModel 
     * @param {PlatformUserService} platformUserService 
     */
    constructor(saveGameModel, platformUserService) {
        super(saveGameModel);

        this._platformUserService = platformUserService;
    }

    async load() {
        const savegameString = await this._platformUserService.getSavegame();
        if (!savegameString) {
            this._saveGameModel.reset();
            console.log(`[${PlatformSavegameStrategy.name}] Save game doesn't exist!`);
            return;
        }

        try {
            await this._saveGameModel.deserialize(savegameString);
            console.log(`[${PlatformSavegameStrategy.name}] Save game loaded successfully!`);
        } catch (ex) {
            console.warn(`[${PlatformSavegameStrategy.name}] Unable to load save game. Resetting save game.`, ex);
            this._saveGameModel.reset();
        }
    }

    async save() {
        try {
            const savegameString = await this._saveGameModel.serialize();
            await this._platformUserService.setSavegame({ savegame: savegameString });
            console.log(`[${PlatformSavegameStrategy.name}] Save game saved successfully!`);
        } catch (ex) {
            console.warn(`[${PlatformSavegameStrategy.name}] Unable to save save game.`, ex);
        }
    }

    async clear() {
        try {
            await this._platformUserService.deleteSavegame();
            console.log(`[${PlatformSavegameStrategy.name}] Save game cleared successfully!`);
        } catch (ex) {
            console.warn(`[${PlatformSavegameStrategy.name}] Unable to clear save game.`, ex);
        }
    }
}